import { Component, OnInit, Input } from '@angular/core';
import {
  ProgramTypesGUID,
  PaymentScheduleTabName
} from '../../../models/_enum-collections';
import { PaymentBatchTableComponent } from '../../shared/payment-batch-table/payment-batch-table.component';

@Component({
  selector: 'app-csi-payment-schedule-milestone1',
  templateUrl: './csi-payment-schedule-milestone1.component.html',
  styleUrls: ['./csi-payment-schedule-milestone1.component.scss'],
  standalone: true,
  imports: [PaymentBatchTableComponent]
})
export class CsiPaymentScheduleMilestone1Component implements OnInit {
  @Input() program: ProgramTypesGUID | null = null;
  tabName!: PaymentScheduleTabName;

  ngOnInit(): void {
    this.tabName = PaymentScheduleTabName.Milestone1;
  }
}
